import { Component } from '@angular/core';
import { MunilyNotificationCardFooter, MunilyNotificationCardType } from 'src/app/common-components/notification-card/notification-card.types';

@Component({
  selector: 'app-notification-card-playground',
  templateUrl: './notification-card-playground.component.html',
  styleUrls: ['./notification-card-playground.component.scss'],
})
export class NotificationCardPlaygroundComponent {
  type: MunilyNotificationCardType = 'toggle';
  checked = true;

  readonly footer: MunilyNotificationCardFooter = {
    label: 'Recordatorios activos',
    value: '48 hrs. | 24 hrs. | 12 hrs. | 2 hrs.',
  };
}

